import page0 from "./_0_job-order-cover-sheet";
import page1 from "./_1_preliminary-questions";
import page2 from "./_2_job-offer-information";
import page3 from "./_3_minimum-job-qualifications-requirements";
import page4 from "./_4_place-of-employment-information";
import page5 from "./_5_housing-information";
import page6, {
  createSchema as createPage6,
} from "./_6_provision-of-meals-and-transportation";
import page7 from "./_7_referral-and-hiring-instructions";
import page8 from "./_8_conditions-of-employment-and-assurances";
import page9 from "./_9_addendum_A-crops";
import page10 from "./_10_addendum_B_place_of_employment";
import page11 from "./_11_addendum_B(D)_additional_housing_location";
import page12 from "./_12_addendum-c";
import page13 from "./_13_state_workface_agency";

const form_meta = {
  code: "Form ETA-790 / Form ETA-790A",
  name: "H-2A Agricultural Clearance Order",
  version: "Processed under 2022 H-2A Final Rule",
};

const form_nav = [
  {
    name: "Job Order Cover Sheet",
    symbol: "document",
  },
  {
    name: "Preliminary Questions",
    prefix: "PQ",
    symbol: "list",
  },
  {
    name: "Job Offer Information",
    prefix: "A",
  },
  {
    name: "Minimum Job <br/>Qualifications/Requirements",
    prefix: "B",
  },
  {
    name: "Place of Employment Information",
    prefix: "C",
  },
  {
    name: "Housing Information",
    prefix: "D",
  },
  {
    name: "Provision of Meals and<br/>Transportation",
    prefix: "E/F",
  },
  {
    name: "Referral and Hiring Instructions",
    prefix: "G",
  },
  {
    name: "Conditions of Employment <br/>and Assurances",
    prefix: "I",
  },
  {
    name: "Addendum A - Additional Crops and/or Agricultural Activities",
    prefix: "ADD <br/>A",
    classes: "label-prefix-appx",
    relevantValue: "eta_790a_addendum_a",
  },
  {
    name: "Addendum B - Additional Place of Employment Information",
    prefix: "ADD <br/>B",
    classes: "label-prefix-appx",
    relevantValue: "eta_790a_addendum_b_employment",
  },
  {
    name: "Addendum B - Additional <br/>Housing Location",
    prefix: "ADD <br/>B",
    classes: "label-prefix-appx",
    relevantValue: "eta_790a_addendum_b_housing",
  },
  {
    name: "Addendum C - Material Terms<br/> and Conditions of the Job Offer",
    prefix: "ADD <br/>C",
    classes: "label-prefix-appx",
    relevantValue: "eta_790a_addendum_c",
  },
  {
    name: "State Workforce Agency (SWA) <br/>Selection",
    prefix: "SWA",
    classes: "label-prefix-appx",
  },
];

// Create base schema array
const uiSchema = [
  page0,
  page1,
  page2,
  page3,
  page4,
  page5,
  page6, // Use default initially
  page7,
  page8,
  page9,
  page10,
  page11,
  page12,
  page13,
];

// Instead of modifying the array directly, create a new function
const getSchemaWithState = (state) => {
  if (!state) return uiSchema;
  uiSchema[6] = createPage6(state);
  return uiSchema;
};

export { form_meta, form_nav, getSchemaWithState };
export default uiSchema;
